const environment: string = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV
  : "local"

export default environment
